module.exports = __webpack_public_path__ + "static/icon-seguranca-f04cf438c8f8778ccc978f8e585fd14e.png";